
import { Navigate } from 'react-router-dom';
import { getUserID } from './utils/storage';


const PrivateRoute = ({ children }) => {
  const isLoggedIn = !!getUserID();
  return isLoggedIn ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;
